import { initReactQueryAuth } from 'react-query-auth';

// import { ADMIN_PANEL_OWNER } from '@/config';
import {
  AuthUser,
  getUser,
  LoginCredentialsDTO,
  loginWithEmailAndPassword,
  UserResponse,
  CompanyRole as Role,
  isHardCodedAdmin,
} from '../features/auth';
import storage from '../utils/storage';

export enum ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
  PROJECT_OWNER = 'PROJECT_OWNER',
  PROJECT_CONTRIBUTOR = 'PROJECT_CONTRIBUTOR',
  PROJECT_VIEWER = 'PROJECT_VIEWER',
}

/**
 * Use Hard-coded ADMIN user only!
 *
 * @date 2025/10/30
 *
 * @param user
 * @returns
 */
export const isTasoAIAdmin = (user: AuthUser | undefined | null) => {
  if (!user) return false;

  return isHardCodedAdmin(user.email);

  // !legacy date to check database definition...
  // const condition = (cr: Role) => cr.company.id == Number(ADMIN_PANEL_OWNER);
  // const owner = user.company_roles.find(condition);
  // if (!owner) return false;
  // const roleType = owner.roles[0].name;
  // return roleType === ROLES.ADMIN;
};

export async function handleUserResponse(data: UserResponse) {
  const { token, ...user } = data;
  // ! == check `ADMIN` role for admin-panel
  // @2025/09/30
  if (!isTasoAIAdmin(user)) {
    throw new Error('Access denied!');
  }
  if (token) {
    // update token in browser cache
    storage.setToken(token);
    storage.setLoginTime();
  }
  return user as AuthUser;
}

/**
 * Fetch user info with cached token, result could be `null` if token expired.
 * Stronger way to load user through token, with `try...catch`.
 *
 * @returns user | null
 */
async function loadUser() {
  // check token expiry first
  const isExpired = storage.isTokenExpired();
  if (isExpired) {
    const lastLogin = storage.getLoginTime();
    // console.warn(`### using expired token, last login time is: ${lastLogin}`);
    // if expired detected, return null
    return null;
  }
  if (storage.getToken()) {
    // FIXME: trying to get logged in user info with a cached token ...
    // null returned, if token is expired
    // @2023/09/07
    try {
      const response = await getUser();
      return await handleUserResponse(response);
    } catch (error) {
      console.error(`## got error on fetching user!!!`);
      return null;
    }
  }
  return null;
}

async function loginFn(data: LoginCredentialsDTO) {
  const response = await loginWithEmailAndPassword(data);
  return await handleUserResponse(response);
}

async function logoutFn() {
  storage.clearToken();
  window.location.assign(window.location.origin);
}

const authConfig = {
  loadUser,
  loginFn,
  logoutFn,
  registerFn: async () => {
    throw new Error('Registration is not supported');
  },
  LoaderComponent() {
    return <div></div>;
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  LoginCredentialsDTO
>(authConfig);
